// 繁體中文表格（機器翻譯，未經人工審校 — ruling G4）。
// The Traditional Chinese table: machine-written from the English table, unread by a native
// reader. Same keys, kinds and placeholders as en.js — held by test/tables.test.js.
const ART_GONE = 'This art is too detailed for the size — enlarge it';
const BASE_PIECES = 'Parts on the tag sit too far apart to bridge a base — add a base margin, bring them closer, or shrink the art';
const INTERNAL = 'Something went wrong — try again';
const FATAL = 'Could not load the model builder — refresh the page';
const S = {
  title: "四層名牌",
  cap: "字母高度（公厘）",
  spacing: "字母間距",
  textHint: "按 Enter 換行 · 最多 3 行",
  dir: {
    h: "橫排",
    v: "直排",
  },
  align: {
    h: {
      start: "左",
      center: "置中",
      end: "右",
    },
    v: {
      start: "頂部",
      center: "中間",
      end: "底部",
    },
  },
  lineGap: "行距",
  layers: "顏色分層",
  layerCount: "層數",
  base: "底座",
  ring: "邊緣",
  textLayer: "字母",
  width: "寬度",
  height: "厚度",
  mm: " 公厘",
  looks: "配色",
  loop: "鑰匙圈掛孔",
  pos: {
    none: "無",
    left: "左",
    right: "右",
    top: "頂部",
  },
  hole: "孔寬",
  ringW: "掛環邊",
  print: "列印",
  layerHeight: "層高",
  mode: {
    multi: "多色（CFS / AMS）",
    swap: "單噴頭，按層換色",
  },
  zTable: (color, z, layer) => `在 ${z.toFixed(2)} 公厘處（第 ${layer} 層）切換到 ${color}`,
  size: (w, h, z) => `${w.toFixed(1)} × ${h.toFixed(1)} × ${z.toFixed(1)} 公厘`,
  dlstl: "下載 STL",
  copied: "已複製",
  stillBuilding: "仍在產生——較長的多行文字可能需要約一分鐘",
  loadingFont: (got, total) => `正在載入字型 ${got.toFixed(1)} / ${total.toFixed(1)} MB`,
  notice: {
    loadFailed: (family) => `無法載入 ${family}——請檢查網路連線 · 繼續使用目前字型`,
    capRaised: (family, cap) => `字母高度已設為 ${cap} 公厘——這是 ${family} 能清晰列印的最小尺寸`,
  },
  issue: {
    "missing-glyph": (p) => `字型 ${String(p.font).replace(/@\d+$/, '')} 缺少這些字元：${p.chars.join(' ')}`,
    "thin-ring": (p) => `第 ${p.band + 1} 層的邊緣太薄（${p.w} 公厘）——應不小於 0.8 公厘`,
    "thin-stroke": (p) => p.minCap
      ? `此字型從 ${p.minCap} 公厘起才能清晰列印——請把字母高度提到至少 ${p.minCap} 公厘`
      : `${p.chars.join(' ')} 的筆畫比 0.4 公厘噴嘴還細——請放大或選更粗的字型`,
    "bed-fit": (p) => `牌子為 ${p.w.toFixed(0)} × ${p.h.toFixed(0)} 公厘——可能超出 220 公厘列印床`,
    "loop-float": () => '掛孔沒有連在牌子上——請移動它或加大底座邊距',
    "thin-art": () => '圖案的部分筆畫比 0.4 公厘噴嘴還細——請放大或換筆畫更粗的圖案',
    "icon-max": (p) => `圖案最大可為 ${p.max} 公厘——已按該尺寸顯示`,
    "art-gone": () => '圖案對這個尺寸來說太精細——請放大圖案',
    "base-pieces": () => '牌子上的零件相距太遠，底座無法連接——請加大底座邊距、拉近零件或縮小圖案',
  },
  errorCode: {
    "build-timeout": "產生 2 分鐘未完成，已重新開始——請減少字母或換字型",
    stale: "有更新的修改到來",
    empty: "沒有可列印的字母",
    "font-load": "字型未能載入",
    internal: "出了點問題——請再試一次",
    "base-pieces": "牌子上的零件相距太遠，底座無法連接——請加大底座邊距、拉近零件或縮小圖案",
    "art-gone": "圖案對這個尺寸來說太精細——請放大",
    engine: "出了點問題——請再試一次",
    fatal: "無法載入模型產生器——請重新整理頁面",
  },
  fatal: "無法載入模型產生器——請重新整理頁面",
  icon: "圖案或標誌（SVG）",
  unpick: "移除圖案",
  iconPos: {
    left: "左",
    right: "右",
    above: "上方",
  },
  iconSize: "圖案大小",
  iconGap: "間隙",
  pct: (k) => `${Math.round(k * 100)}%`,
  needFile: "選擇圖案或標誌的 SVG 檔案——它只留在您的裝置上，不會傳送到任何地方",
  artKept: "圖案只存在於目前分頁——重新整理後需重新選擇檔案",
  keptOld: "（仍在使用先前的圖案）",
  thumb: "已讀取圖案的預覽",
  shareNoIcon: "此連結不含圖案檔案——開啟的人需要自行選擇 SVG",
  linkNeedsIcon: "此設計使用了檔案裡的圖案，但連結不含該檔案——請選擇 SVG 檔案補上",
  aboutP: "設計 2–4 色的名牌或鑰匙圈。名字支援泰文、英文、中文或日文，可多行或直排，自選字型，下載多色列印用的 3MF 或單色列印用的 STL。瀏覽器裡免費用，無需安裝。還可以把 SVG 檔案的標誌或圖示放在名字旁邊 — 檔案只留在你的裝置上，不會被傳送到任何地方。",
};
export default S;
